import { IonBadge, IonButton, IonCol, IonGrid, IonRow, IonSkeletonText } from "@ionic/react";
import { useQuery } from "@tanstack/react-query";
import React, { useEffect } from "react";
import { ApiService } from "../../services";

export const CategoryFilter = (props: any) => {
  const { onFilterChange } = props;
  const [activeFilter, setActiveFilter] = React.useState<number>(0);
  const { data, isLoading } = useQuery({
    queryKey: ["news", "categories"],
    queryFn: () => ApiService.get("news-categories"),
  });

  useEffect(() => {
    onFilterChange(activeFilter);
  }, [activeFilter, onFilterChange]);

  return (
    <IonGrid
      style={{
        marginRight: "-24px",
        paddingLeft: 0,
      }}
    >
      <IonRow className={"ion-no-padding"}>
        <IonCol
          style={{
            display: "flex",
            flexWrap: "nowrap",
            overflowX: "scroll",
            overflowY: "hidden",
          }}
        >
          {isLoading ? (
            <IonSkeletonText animated={true} style={{ height: "40px", width: "120px" }} />
          ) : (
            <>
              <IonButton fill={activeFilter === 0 ? "solid" : "outline"} color={"medium"} onClick={() => setActiveFilter(0)}>
                All{" "}
                <IonBadge
                  color={activeFilter === 0 ? "dark" : "medium"}
                  style={{
                    marginLeft: "0.5em",
                  }}
                >
                  {data.data.reduce((accum: number, current: any) => {
                    return accum + current.count;
                  }, 0)}
                </IonBadge>
              </IonButton>

              {data.data.map((category: any) => (
                <IonButton
                  key={"category-" + category.id}
                  fill={activeFilter === category.id ? "solid" : "outline"}
                  color={"medium"}
                  onClick={() => {
                    setActiveFilter(category.id);
                  }}
                >
                  {category.name}{" "}
                  <IonBadge
                    color={activeFilter === category.id ? "dark" : "medium"}
                    style={{
                      marginLeft: "0.5em",
                    }}
                  >
                    {category.count}
                  </IonBadge>
                </IonButton>
              ))}
            </>
          )}
        </IonCol>
      </IonRow>
    </IonGrid>
  );
};
